if (!customElements.get('sibling-price-difference')) {
  customElements.define('sibling-price-difference', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.unsubscribeVariant = subscribe(theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const sectionId = this.productInfo?.sectionId || this.dataset.sectionId;
        if (data.sectionId !== sectionId) return;

        const replacement = data.html.getElementById(this.id);
        this.innerHTML = replacement?.innerHTML || '';
      });
      this.unsubscribeSelection = subscribe(theme.PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (this.productInfo?.contains(data.event.target)) this.textContent = '';
      });
    }

    disconnectedCallback() {
      this.unsubscribeVariant?.();
      this.unsubscribeSelection?.();
    }
  });
}
